"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.onlogout = exports.onSetToken = exports.onSetUserToken = exports.onSetUser = exports.UserSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const storage_1 = require("../../utils/storage");
const initialState = storage_1.AppStorage.getItem("user", {
    user: undefined,
    token: undefined,
});
exports.UserSlice = (0, toolkit_1.createSlice)({
    name: "user",
    initialState,
    reducers: {
        onSetUser: (state, action) => {
            state.user = action.payload;
            storage_1.AppStorage.setItem("user", state);
        },
        onSetToken: (state, action) => {
            state.token = action.payload;
            storage_1.AppStorage.setItem("token", state.token);
        },
        onSetUserToken: (state, action) => {
            // console.log("user",action)
            state.user = action.payload.user;
            state.token = action.payload.token;
            storage_1.AppStorage.setItem("user", state);
        },
        onlogout: (state) => {
            state.user = null;
            state.token = null;
            storage_1.AppStorage.setItem("user", state);
            storage_1.AppStorage.clear();
        },
    },
});
_a = exports.UserSlice.actions, exports.onSetUser = _a.onSetUser, exports.onSetUserToken = _a.onSetUserToken, exports.onSetToken = _a.onSetToken, exports.onlogout = _a.onlogout;
exports.default = exports.UserSlice.reducer;
